var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-dark",attrs:{"id":"app"}},[_c('NavBar'),_c('div',{staticClass:"px-sa pb-sa"},[_c('router-view',{staticClass:"container"})],1),_c('ToastArea')],1)}
var staticRenderFns = []

export { render, staticRenderFns }